var render = function render(_c, _vm) {
  return _c(
    "div",
    { staticClass: "loader-container", class: _vm.props.customClass },
    [_c("span", { staticClass: "loader", class: _vm.props.loaderClass })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }